import { rgba } from 'polished';

const styles = theme => ({
  root: {
    flex: 1,
    position: 'relative',
    display: 'flex',
    margin: [20, 'auto'],
    maxWidth: 1400,
    width: '100%'
  },
  frame: {
    position: 'absolute',
    zIndex: 1,
    left: 10,
    right: 10,
    top: 0,
    bottom: 0,
    outline: `2px solid ${theme.color.background.dark}`,
    outlineOffset: 2,
    backgroundColor: rgba(theme.color.background.dark, theme.color.alpha)
  },
  content: {
    position: 'relative',
    zIndex: 2,
    flex: 1,
    margin: props => (props.flushLeft ? [0, 0, 20, 0] : [0, 20, 20, 20]),
    padding: [20, 20, 20, 20],

    '& > *:last-child, & > article > *:last-child': {
      marginBottom: 0
    }
  },

  '@media screen and (min-width: 768px)': {
    root: {
      minHeight: 1,
      maxWidth: 1500
    },
    frame: {
      left: 30,
      right: 30,
      top: -20,
      bottom: -20
    },
    content: {
      margin: props => (props.flushLeft ? [10, 20, 10, 0] : [10, 60, 10, 60]),
      padding: [20, 20, 20, 20],

      '& img': {
        maxWidth: '80%'
      }
    }
  },

  '@media screen and (min-width: 1025px)': {
    content: {
      margin: props => (props.flushLeft ? [20, 20, 20, 0] : [20, 80, 20, 80]),
      padding: [30, 30, 30, 30]
    }
  }
});

export { styles };
